module.exports = __webpack_public_path__ + "img/w3_circle_white.ab7fe98e.png";